class ProductDescription extends HTMLElement {
    constructor() {
      super();

      this._selectors = {
        expandableList: '[js-expandable-list]',
        list: '[js-specification-list]',
        expandButton: '[js-expand-button]',
        tabsCarousel: 'div[js-description-tabs] div[js-carousel]',
        tabs: '[js-description-tabs]',
        tab: '[js-description-tab]',
        panelBlock: '[js-description-block]'
      }

      this.expandButton = this.querySelector(this._selectors.expandButton)
      this.expandableList = this.querySelector(this._selectors.expandableList)
      this.tabsContainer = this.querySelector(this._selectors.tabs)
      this.tabs = this.querySelectorAll(this._selectors.tab)
      this.panelBlocks = this.querySelectorAll(this._selectors.panelBlock)

      this.tabsCarousel = this.querySelector(this._selectors.tabsCarousel)

      this.tabsKeys = Array.from(this.tabs).reduce((acc, tab) => {
        const id = tab.querySelector('a').getAttribute('href').replace('#', '')
        acc[id] = tab
        return acc;
      }, {});

      this.sectionsInfo = {};

      this.panelBlocks.forEach(section => {
        this.sectionsInfo[section.id] = section;
      });

    }

    connectedCallback(){
      this.expandButton.addEventListener('click', (evt) => {
        this.expandableList.setAttribute('data-mobile-expanded', true)
        this.expandButton.remove();
      })

      document.addEventListener('scroll', this.handleStickyScroll.bind(this));

      this.tabs.forEach((tab) => {
        tab.querySelector('a').addEventListener('click', (evt) => {
          evt.preventDefault();

          const targetSection = evt.target.getAttribute('href')
          const targetElement = this.querySelector(targetSection)
          const offset = 80;

          const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;

          const offsetPosition = elementPosition - offset;

          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
          });

        })
      })
    
    }

    setActiveTab(selectedTab){
      this.tabs.forEach((tab, index) => {
        if(tab.classList.contains('active') && tab !== selectedTab){
          tab.classList.remove('active')
        } else if(tab === selectedTab && !tab.classList.contains('active')){
          tab.classList.add('active')

          if(this.tabsCarousel?.swiper){
            this.tabsCarousel.swiper.slideTo(index);          
          }

        }
      })
    }

    findCurrentSection() {
      const offset = 100;
      let closestSectionId = null;
    
      Object.entries(this.sectionsInfo).forEach(([id, section]) => {
        const sectionTop = section.offsetTop; // Distance from the top of the document to the top of the section
        const sectionHeight = section.offsetHeight; // The height of the section
        const scrollPosition = window.scrollY; // How far we've scrolled from the top of the document
    
        if (scrollPosition + offset >= sectionTop && scrollPosition + offset < sectionTop + sectionHeight) {
          closestSectionId = id;
        }
      });
    
      return closestSectionId;
    }

    handleStickyScroll() {
      const currentSectionId = this.findCurrentSection();
      if (currentSectionId) {
        const selectedTab = this.tabsKeys[currentSectionId];
        if (selectedTab) this.setActiveTab(selectedTab);
      }
    
      const container = this;
      const tabs = this.tabsContainer;
    
      // --- START: MODIFICATION ---
      // 1. Create a placeholder if it doesn't exist
      let placeholder = container.querySelector('.sticky-tabs-placeholder');
      if (!placeholder) {
        placeholder = document.createElement('div');
        placeholder.className = 'sticky-tabs-placeholder';
        tabs.parentNode.insertBefore(placeholder, tabs); // Insert placeholder before the tabs
        placeholder.style.display = 'none'; // Start hidden
      }
      // --- END: MODIFICATION ---
    
      const containerTop = container.getBoundingClientRect().top;
      const containerBottom = container.getBoundingClientRect().bottom;
    
      const isWithinStickyZone = containerTop < 0 && containerBottom > 0;
    
      if (isWithinStickyZone) {
        if (!tabs.classList.contains('fixed')) {
          // --- START: MODIFICATION ---
          // 2. Before making it fixed, set the placeholder's height
          const tabsHeight = tabs.offsetHeight;
          placeholder.style.height = `${tabsHeight}px`;
          placeholder.style.display = 'block';
          // --- END: MODIFICATION ---
          
          tabs.classList.add('fixed');
        }
      } else {
        if (tabs.classList.contains('fixed')) {
          tabs.classList.remove('fixed');
          
          // --- START: MODIFICATION ---
          // 3. Hide the placeholder when it's no longer sticky
          placeholder.style.display = 'none';
          // --- END: MODIFICATION ---
        }
      }
    }

}

if (!customElements.get('product-description')) {
    customElements.define("product-description", ProductDescription);
}